import { render, staticRenderFns } from "./IconHeaderCard.vue?vue&type=template&id=3b4d3156&scoped=true"
import script from "./IconHeaderCard.vue?vue&type=script&lang=js"
export * from "./IconHeaderCard.vue?vue&type=script&lang=js"
import style0 from "./IconHeaderCard.vue?vue&type=style&index=0&id=3b4d3156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d3156",
  null
  
)

export default component.exports